import { render, staticRenderFns } from "./wxLogin.vue?vue&type=template&id=2bbb8329&"
import script from "./wxLogin.vue?vue&type=script&lang=js&"
export * from "./wxLogin.vue?vue&type=script&lang=js&"
import style0 from "./wxLogin.vue?vue&type=style&index=0&id=2bbb8329&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports